// src/features/profile/components/ChatList.jsx
import { useEffect, useState } from 'react';
import { Alert, Container, ListGroup, Spinner } from 'react-bootstrap';
import { fetchChatGroupList, fetchChatList } from './Api'; // Adjust path as needed
import GroupMessageModal from './GroupMessageModal'; // ✅ new
import MessageModal from './MessageModal';

const ChatList = () => {
  const [chatList, setChatList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groupLoading, setGroupLoading] = useState(true);
  const [error, setError] = useState('');
  const [groupError, setGroupError] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null); // ✅ for group modal

  useEffect(() => {
    const loadChatList = async () => {
      try {
        const data = await fetchChatList();
        setChatList(data);
      } catch (err) {
        setError(err.message || 'Failed to load chat list');
      } finally {
        setLoading(false);
      }
    };

    const loadGroupList = async () => {
      try {
        const data = await fetchChatGroupList();
        setGroupList(data);
      } catch (err) {
        setGroupError(err.message || 'Failed to load group list');
      } finally {
        setGroupLoading(false);
      }
    };

    loadChatList();
    loadGroupList();
  }, []);

  return (
    <Container
      className="mt-3 p-0 d-flex flex-column"

    >

      {loading && (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      {!loading && !error && chatList.length === 0 && (
        <Alert variant="info">No conversations found.</Alert>
      )}

      <ListGroup 
      style={{ 
        maxHeight: '100%', 
        overflowY: 'auto', 
        padding: '10px'}}>
        {chatList.map((chat) => (
          <ListGroup.Item
            key={chat.conversation_id}
            action
            onClick={() =>
              setSelectedUser({
                id: chat.other_user_id,
                name: chat.other_user_name,
                conversation_id: chat.conversation_id,
                friendship_status: chat.friendship_status,
              })
            }
            className="d-flex align-items-center mb-2"
            style={{
              borderRadius: '10px',
              padding: '10px',
              backgroundColor: '#b84a13',
              border: 'none',
              fontSize: '16px',
              color: '#FFFAF0',
             // background: 'linear-gradient(90deg, #ff9b45, #db5)', // vibrant gradient
           //   color: '#fff',
             // boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            }}
          >
            {chat.other_user_profile_image ? (
              <img
                src={`${chat.other_user_profile_image}?t=${Date.now()}`}
                alt={chat.other_user_name || 'Avatar'}
                className="rounded-circle me-3"
                style={{ width: '50px', height: '50px', objectFit: 'cover' }}
              />
            ) : (
              <div
                className="bg-secondary rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: '50px',
                  height: '50px',
                  fontSize: '24px',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              >
                {chat.other_user_name?.charAt(0).toUpperCase() || 'U'}
              </div>
            )}

            <div className="fw-bold">{chat.other_user_name}</div>
          </ListGroup.Item>


        ))}
      </ListGroup>





      {/* Group List */}
      <h5 className="mt-4 mb-3" 
      style={{ 
        fontSize: '20px',
        fontWeight: '700',
        fontStyle: 'bolder',
        color: '#740A03',
        fontFamily: 'Arial, sans-serif', 

      }}>

        MATCH CHAT</h5>

      {groupLoading && (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      )}

      {groupError && <Alert variant="danger">{groupError}</Alert>}

      {!groupLoading && !groupError && groupList.length === 0 && (
        <Alert variant="info">No groups found.</Alert>
      )}

      <ListGroup style={{ maxHeight: '100%', overflowY: 'auto', padding: '10px' }}>
        {groupList.map((group) => (
          <ListGroup.Item
            key={group.group_id}
            action
            onClick={() =>
              setSelectedGroup({
                chatName: group.name,
                chatId: group.group_id,
              })
            }
            className="d-flex align-items-center mb-2"
            style={{
              borderRadius: '10px',
              padding: '10px',
              backgroundColor: '#b84a13',
              border: 'none',
              fontSize: '16px',
              color: '#FFFAF0',
         //     background: 'linear-gradient(90deg, #ff9b45, #db5)', // vibrant gradient
          //    color: '#fff',
            //  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
              cursor: 'pointer',
            }}
          >
            <div className="fw-bold">{group.name}</div>
          </ListGroup.Item>
        ))}
      </ListGroup>








      {selectedUser && (
        <MessageModal
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}

      {selectedGroup && (
        <GroupMessageModal
          chatName={selectedGroup.chatName}
          chatId={selectedGroup.chatId}
          onClose={() => setSelectedGroup(null)}
        />
      )}
    </Container>
  );
};

export default ChatList;
